<section class="inner-page-wrapper py-[120px] lg:py-[250px]">
    <h1 class="font-headline text-24 font-medium leading-28 text-black md:text-50 md:leading-58">
        Seite nicht gefunden
    </h1>
    <div class="max-w-[750px] py-24">
        <p class="font-text text-16 leading-27 text-black">
            Leider können wir die von Ihnen angeforderte Seite nicht finden. Das könnte daran liegen, dass Sie eine
            falsche oder eine veraltete URL aufgerufen haben.
        </p>
        <p class="mt-12 font-text text-16 leading-27 text-black">
            Bitte überprüfen Sie Ihre Eingaben noch einmal oder versuchen Sie über unsere Startseite den von Ihnen
            gewünschten Inhalt zu finden.
        </p>
    </div>
    <a class="button-primary md:max-w-[300px]" [hyundaiRouterLink]="'/' + dealer().slug">Zur Startseite</a>
</section>
